import { Lock } from "lucide-react";
import { useCatalog } from "../../hooks/useData";
import { INTERACTION_FR, METRIC_FR } from "../../lib/labels";
import { MODE_FR } from "../../lib/api";
import { GameIcon } from "../../components/game/GameTarget";
import { PageHeader, Panel } from "./CareLayout";

export default function Missions() {
  const { data: c } = useCatalog();
  if (!c) return null;
  return (
    <div data-testid="care-missions">
      <PageHeader title="Missions" sub={`Catalogue des missions et règles adaptatives · règles v${c.rules_version}`} />
      <Panel title="Niveau 1 · Le Village (jouable)" testId="missions-village">
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {c.missions.map((m) => (
            <div key={m.key} className="flex gap-3 rounded-2xl border border-border p-4" data-testid={`mission-card-${m.key}`}>
              <div className="h-16 w-16 shrink-0 rounded-xl bg-primary/10"><GameIcon kind={m.key} size={64} /></div>
              <div className="text-sm"><p className="font-bold">{m.order}. {m.name_fr}</p><p className="text-foreground/75">{m.movement_fr}</p>
                <p className="mt-1 text-xs text-muted-foreground/80">{METRIC_FR[m.metric]} · {INTERACTION_FR[m.interaction]} · {m.reps} rép.{m.bilateral ? " · inclut bilatéral" : ""}</p></div>
            </div>
          ))}
        </div>
      </Panel>
      <Panel title="Règles du moteur de difficulté adaptative" className="mt-6" testId="missions-rules">
        <div className="grid gap-3 sm:grid-cols-3">
          {Object.entries(c.mode_bands).map(([k, [lo, hi]]) => (
            <div key={k} className="rounded-xl bg-muted p-4"><p className="font-bold">{MODE_FR[k]}</p><p className="font-mono text-sm">{Math.round(lo * 100)}–{Math.round(hi * 100)} % de la limite sûre</p></div>
          ))}
        </div>
        <ul className="mt-4 list-disc space-y-1 pl-5 text-sm text-foreground/75">
          <li>Limite sûre = min(paramètre clinique, calibration du jour, % d'amplitude max autorisé). Jamais dépassée.</li>
          <li>~{Math.round(c.affected_side_ratio * 100)} % des cibles unilatérales sur le côté atteint ; le côté sain et les mouvements bilatéraux restent sollicités.</li>
          <li>Les missions dont le mouvement est interdit par le thérapeute sont exclues automatiquement.</li>
          <li>Douleur ≥ {c.pain_alert_threshold}/10 : message de pause, aucune poursuite automatique.</li>
        </ul>
      </Panel>
      <Panel title="Niveaux à venir (aperçus)" className="mt-6" testId="missions-future">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {c.levels.filter((l) => !l.playable).map((l) => (
            <div key={l.key} className="overflow-hidden rounded-2xl border border-border">
              <img decoding="async" src={`/assets/level${l.order}.webp`} alt={l.name_fr} className="h-28 w-full object-cover" />
              <div className="p-3 text-sm"><p className="flex items-center gap-1 font-bold"><Lock className="h-3.5 w-3.5 text-muted-foreground/80" />{l.order}. {l.name_fr}</p><p className="text-xs text-muted-foreground">{l.objectives_fr}</p></div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
